import * as React from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';

export default function PopUpMenu({ mainEl, children }) {
  // Show small menu with settings and logout
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div onClick={handleClick}>{mainEl}</div>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        // fixing the closing and opening of the pop up menu
        onClose={handleClose}
        onClick={handleClose}
      >
        <Paper
          elevation={0}
          sx={{
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.20))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              //bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          }}
        //transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        //anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        />

        {/* This is what we are going to use to show the custom components */}
        {children.map(({ link, text, onClick }, index) =>
          <MenuItem 
            // component={Link}
            to={link}
            key={index}
            onClick={onClick}
          >
            {text}
          </MenuItem>
        )}
      </Menu>
    </>
  );
}